export interface ScheduleSlot {
  time: string;
  name: string;
}

export interface ScheduleDay {
  day: string;
  slots: ScheduleSlot[];
}

export const termSchedule: ScheduleDay[] = [
  {
    day: "월",
    slots: [
      { time: "14:00 - 16:00", name: "초등부 개념반" },
      { time: "16:30 - 18:30", name: "중등부 내신반" },
      { time: "19:00 - 21:30", name: "고등부 수Ⅰ반" },
    ],
  },
  {
    day: "화",
    slots: [
      { time: "14:00 - 16:00", name: "초등부 사고력반" },
      { time: "16:30 - 18:30", name: "중등부 심화반" },
      { time: "19:00 - 21:30", name: "고등부 수Ⅱ반" },
    ],
  },
  {
    day: "수",
    slots: [
      { time: "14:00 - 16:00", name: "초등부 개념반" },
      { time: "16:30 - 18:30", name: "중등부 내신반" },
      { time: "19:00 - 21:30", name: "고등부 미적분반" },
    ],
  },
  {
    day: "목",
    slots: [
      { time: "14:00 - 16:00", name: "초등부 사고력반" },
      { time: "16:30 - 18:30", name: "중등부 심화반" },
      { time: "19:00 - 21:30", name: "고등부 수Ⅰ반" },
    ],
  },
  {
    day: "금",
    slots: [
      { time: "14:00 - 16:00", name: "초등부 개념반" },
      { time: "16:30 - 18:30", name: "중등부 내신반" },
      { time: "19:00 - 21:30", name: "고등부 미적분반" },
    ],
  },
  {
    day: "토",
    slots: [
      { time: "10:00 - 12:30", name: "전 학년 오답 클리닉" },
      { time: "13:00 - 15:30", name: "중등부 심화 특강" },
      { time: "16:00 - 18:30", name: "고등부 모의고사반" },
    ],
  },
];

export const vacationSchedule: ScheduleDay[] = [
  {
    day: "월",
    slots: [
      { time: "09:00 - 12:00", name: "선행 특강 (초·중)" },
      { time: "13:00 - 16:00", name: "선행 특강 (고등)" },
      { time: "16:30 - 18:30", name: "오답 · 복습 클리닉" },
    ],
  },
  {
    day: "화",
    slots: [
      { time: "09:00 - 12:00", name: "선행 특강 (초·중)" },
      { time: "13:00 - 16:00", name: "선행 특강 (고등)" },
      { time: "16:30 - 18:30", name: "오답 · 복습 클리닉" },
    ],
  },
  {
    day: "수",
    slots: [
      { time: "09:00 - 12:00", name: "선행 특강 (초·중)" },
      { time: "13:00 - 16:00", name: "선행 특강 (고등)" },
      { time: "16:30 - 18:30", name: "오답 · 복습 클리닉" },
    ],
  },
  {
    day: "목",
    slots: [
      { time: "09:00 - 12:00", name: "선행 특강 (초·중)" },
      { time: "13:00 - 16:00", name: "선행 특강 (고등)" },
      { time: "16:30 - 18:30", name: "오답 · 복습 클리닉" },
    ],
  },
  {
    day: "금",
    slots: [
      { time: "09:00 - 12:00", name: "선행 특강 (초·중)" },
      { time: "13:00 - 16:00", name: "선행 특강 (고등)" },
      { time: "16:30 - 18:30", name: "오답 · 복습 클리닉" },
    ],
  },
  {
    day: "토",
    slots: [
      { time: "10:00 - 13:00", name: "집중 몰입 특강" },
      { time: "14:00 - 17:00", name: "취약 단원 보강" },
    ],
  },
];